import { Box, Skeleton } from '@mui/material';

export default function SkeletonBlock({ height = 200, sx = {} }) {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Skeleton
        variant="rectangular"
        height={height}
        animation="wave"
        sx={{
          width: '100%',
          borderRadius: 0, 
        }}
      />
    </Box>
  );
}
